import React, { useEffect, useState } from "react"
import { IModalMessage } from "../../../types/error/IModalMessage"
import { IErrorModel } from "../../../types/error/IErrorModel"
import { IPageResponse } from "../../../types/IPageResponse"
import * as TrinityAPI from "../../../requests/TrinityAPI"
import { ModalPopUp } from "../../common/element/ModalPopUp"
import InfiniteScroll from "react-infinite-scroll-component"
import { IInnRegistryDto } from "../../../types/inn/IInnRegistryDto"
import { CurrencyPayerPopUpListItem } from "./CurrencyPayerPopUpListItem"
import { IInnSuggestion } from "../../../types/inn/IInnSuggestion"

export const CurrencyPayerPopUpList: React.FC<{ visible: boolean; setVisible: (visible: boolean) => void }> = ({
  visible,
  setVisible
}) => {
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const [errors, setErrors] = useState<IErrorModel>()
  const [innList, setInnList] = useState<IPageResponse<IInnRegistryDto>>()
  const [inn, setInn] = useState<IInnRegistryDto>()
  const [searchQuery, setSearchQuery] = useState("")
  const [page, setPage] = useState(0)

  useEffect(() => {
    if (page === 0) {
      fetchInnList()
    }
  }, [page])

  useEffect(() => {
    if (!inn?.inn) {
      setInn({ ...inn, name: "" })
      return
    }
    if (inn.inn.length !== 10 && inn.inn.length !== 12) return
    TrinityAPI.suggestInn(inn.inn, response => {
      if (response.status === 200) {
        const rsp: IInnSuggestion = response.data
        if (rsp.suggestions.length > 0)
          setInn({ ...inn, name: rsp.suggestions[0].value, address: rsp.suggestions[0].data.address.value })
        else setInn({ ...inn, name: "", address: "" })
      }
    })
  }, [inn?.inn])

  const fetchInnList = (isRefetch = false) => {
    TrinityAPI.getCurrencyInnList(isRefetch ? 0 : page, searchQuery, response => {
      if (response.status === 200) {
        const currentItems =
          page === 0 || isRefetch ? new Array<IInnRegistryDto>() : innList?.items || new Array<IInnRegistryDto>()
        !isRefetch && setPage(page + 1)
        setInnList({
          ...innList,
          items: currentItems.concat(response.data.items),
          totalPages: response.data.totalPages
        })
      } else {
        setModalMessage({ title: "Ошибка!", text: "Ошибка загрузки реестра: " + response.data.message })
      }
    })
  }

  const remove = (id: number) => {
    if (!id) return
    TrinityAPI.deleteCurrencyInnRegistryItem(id, response => {
      if (response.status === 200) {
        let newItems = innList?.items.filter(i => i.id !== id) || new Array<IInnRegistryDto>()
        setInnList({ ...innList, items: newItems, totalPages: innList?.totalPages || 0 })
      } else {
        setModalMessage({ title: "Ошибка!", text: "" })
        setErrors(response.data)
      }
    })
  }

  const approve = (currentInn: IInnRegistryDto) => {
    TrinityAPI.approveCurrencyInnRegistryItem(Number(currentInn.id), response => {
      if (response.status === 200) {
        setInn(undefined)

        fetchInnList(true)
      } else {
        setModalMessage({ title: "Ошибка!", text: "" })
        setErrors(response.data)
      }
    })
  }

  const lockUnlock = (currentInn: IInnRegistryDto) => {
    if (currentInn.status === "BLOCKED") {
      approve(currentInn)
    } else {
      TrinityAPI.blockCurrencyInnRegistryItem(Number(currentInn.id), response => {
        if (response.status === 200) {
          setInn(undefined)

          fetchInnList(true)
        } else {
          setModalMessage({ title: "Ошибка!", text: "" })
          setErrors(response.data)
        }
      })
    }
  }

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      setPage(0)
    }
  }

  if (visible) {
    return (
      <section className="user-search-popup">
        <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} error={errors} />
        <div className="container-user-search">
          <button className="close-btn-card" onClick={() => setVisible(false)} />
          <div className="header-user-search-popup">
            <h3 className="heading-chapter">Реестр валютных плательщиков</h3>
            <div className="flex-row-24">
              <input
                type="search"
                className="input-form-search"
                placeholder="Введите название компании"
                onKeyDown={handleKeyDown}
                onChange={e => setSearchQuery(e.target.value)}
              />
            </div>
          </div>
          <div className="inn_wrapper">
            <div className="currency_inn_header_list">
              <p>Название компании</p>
              <p>Адрес</p>
              <p>Статус</p>
              <div />
            </div>
            <ul className="block-list-users">
              <InfiniteScroll
                next={fetchInnList}
                hasMore={page < (innList?.totalPages || 0)}
                loader={<>Загрузка...</>}
                dataLength={innList?.items.length || 0}
                style={{ listStyleType: "none" }}
              >
                {innList?.items.map((i, index) => (
                  <CurrencyPayerPopUpListItem
                    refetch={() => fetchInnList(true)}
                    inn={i}
                    remove={remove}
                    lockUnlock={lockUnlock}
                    approve={approve}
                  />
                ))}
              </InfiniteScroll>
            </ul>
          </div>
        </div>
      </section>
    )
  } else {
    return null
  }
}
